module.exports = __webpack_public_path__ + "static/badge-nominerad-arets-byra-2025-negative-white-2899ba1e598eeafccd2f83b280be6651.svg";